import { gql } from '@apollo/client';
import TableSettingsFragment from '../../fragments/TableSettings/TableSettings';

const getIncomingOrdersSettings = gql`query{
	incomingOrdersContext{
		incomingOrdersSettings
		{
			availableUsers
			{
				avatarUrl
				name
				userId
				username
			}
			supplierOrderStatuses{
				actions
				actionTrigger
				color
				id
				name
				productionStatus
				userMustConfirmAction
			}
			groups{
				id
				name
			}
			views{
				groupId
				id
				name
				settings
			}
			tableSettings {
				...TableSettings
			}
			
		}
	}
}
${TableSettingsFragment}
`;

export default getIncomingOrdersSettings;